import React from 'react';
import { Link } from 'react-router-dom';

const WHATS_NEW_ITEMS = [
    {
        date: 'November 29, 2025',
        title: "Red Light Green Light added",
        gameClass: 'RedLightGreenLight',
        gameLabel: "Red Light Green Light",
        summary: "Red Light Green Light offers a high-stakes dash to the finish line where every move counts and the tension is palpable.",
        bullets: [
            "Players race to the finish line, but can only move when 'Green Light' is called. Move during 'Red Light' and you're sent back to the start.",
            "The game rewards quick reflexes and strategic timing, creating intense moments as players try to outpace each other while avoiding penalties.",
            "A thrilling addition for groups that enjoy fast-paced, competitive games with a simple yet engaging mechanic."
        ],
    },
    {
    date: 'February 21, 2026',
    title: 'Unscramble added',
      gameClass: 'Unscramble',
      gameLabel: 'Unscramble',
    summary: 'Unscramble joins the lineup as a fast word puzzle game built around speed, accuracy, and quick pattern recognition.',
    bullets: [
      'Players race to solve mixed-up words before everyone else',
      'Short rounds make it easy to play as a quick warm-up or between longer games',
      'A strong pick for players who like wordplay with a competitive edge'
    ],
  },
  {
    date: 'February 22, 2026',
    title: 'Who Am I added',
    gameClass: 'WhoAmI',
    gameLabel: 'Who Am I',
    summary: 'Who Am I brings a social deduction and guessing format to the collection, making it easy to jump into playful identity-based rounds.',
    bullets: [
      "Clues given one after another to help you guess the famous person",
      "Up to 10 clues shown - test your historical knowledge!"
    ],
  },
  {
    date: 'March 7, 2026',
    title: 'Rebus added',
    gameClass: 'Rebus',
    gameLabel: 'Rebus',
    summary: 'Rebus introduces picture-and-word puzzle solving, giving players a different kind of brain teaser to compete over.',
    bullets: [
      'Players interpret visual clues to uncover a phrase or answer',
      'The format rewards lateral thinking instead of pure speed alone',
      'A good fit for mixed groups because the challenge feels different from trivia or reflex games', 
      'More puzzles will be added from time to time'
    ],
  },
  {
    date: 'October 11, 2025',
    title: 'Word Search added',
    gameClass: 'WordSearch',
    gameLabel: 'Word Search',
    summary: 'Word Search adds a calmer but still competitive puzzle mode where players scan the grid under pressure and hunt for hidden words.',
    bullets: [
      'Players search the board for target words as quickly as possible',
      'The game mixes relaxed puzzle mechanics with multiplayer competition',
      'A strong alternative for players who want something less frantic than action-heavy rounds'
    ],
  },
  {
    date: 'March 7, 2026',
    title: 'Never Have I Ever added',
    gameClass: 'NeverHaveIEver',
    gameLabel: 'Never Have I Ever',
    summary: 'Never Have I Ever has been added to the game lineup, providing a new way for players to engage and have fun.',
    bullets: [
        'Players take turns making statements starting with "Never have I ever..." and others respond if they have done the action',
        'Points are scored based on responses, and the game continues until a player reaches the winning score',
        'A fun and social game that encourages players to share and learn about each other in a lighthearted way'
    ],
  },
    {
    date: 'March 7, 2026',
    title: 'Mental Maths added',
    gameClass: 'MentalMaths',
    gameLabel: 'Mental Maths',
    summary: 'Mental Maths has been added, providing a new way for players to engage and challenge their arithmetic skills.',
    bullets: [
      'Players solve math problems as quickly and accurately as possible',
        'The game includes a variety of question types, ranging from simple arithmetic to more complex calculations, to keep players entertained',
        'A great way to exercise your brain and improve your mental math skills in a fun and interactive setting'
    ],
  },
  {
    date: 'March 7, 2026',
    title: 'Truth Or Dare added',
    gameClass: 'TruthOrDare',
    gameLabel: 'Truth Or Dare',

    summary: 'Truth Or Dare has been added to the game lineup, offering the classic party game experience with a twist.',
    bullets: [
      'Players choose between answering a question truthfully or performing a dare, with points awarded for participation',
        'The game includes a variety of questions and dares, ranging from lighthearted to daring, to keep players entertained',
        'A great way to break the ice and create memorable moments among friends in a fun and interactive setting',
        'Best played in person with your phones/tablets rather than remotely'
    ],
  },
  {
    date: 'March 10, 2026',
    title: 'New homepage carousel',
    summary: 'The homepage carousel has been redesigned to better highlight featured games and updates, making it easier for players to discover new content and stay informed about the latest changes.',
    bullets: [
        'The new design features larger images and clearer calls to action, encouraging players to explore featured games and updates',
        'The carousel now includes more games and updates, providing a richer experience for players visiting the homepage',
        'The improved layout and navigation make it easier for players to find and engage with the content that interests them, enhancing overall user experience on the platform'
    ],
  },
  {
    date: 'March 1, 2026',
    title: "Darts added",
    gameClass: 'Darts',
    gameLabel: 'Darts',
    summary: "Darts is now available as a new game option, offering players a fun and competitive way to test their aim and strategy.",
    bullets: [
        'Players take turns throwing virtual darts at a target, aiming for high scores and strategic placements',   
        'The game includes various modes and challenges, allowing players to compete in different ways and keep the experience fresh',
        'Darts is a great addition for players who enjoy skill-based games that combine precision and strategy, providing an engaging and entertaining experience for all skill levels'
    ],
  }
  ,
  {
    date: 'August 8, 2025',
    title: "Hangman added", 
    gameClass: 'Hangman',
    gameLabel: 'Hangman',
    summary: "The classic pen and paper game, Hangman, has been added to the game collection, providing a fun and engaging word-guessing experience for players of all ages.",
    bullets: [
        'Players guess letters to reveal a hidden word before running out of attempts',
        'The game includes a variety of word categories and difficulty levels, making it accessible and enjoyable for players of all ages',
        'Hangman is a timeless game that encourages players to think critically and strategically, providing a fun and engaging experience for those who enjoy word games and puzzles'
    ]
  }  ,
  {
    date: 'March 11, 2026',
    title: "Music Theory Quiz added", 
    gameClass: 'MusicTheoryQuiz',
    gameLabel: 'Music Theory Quiz',
    summary: "Test the power of your ear to recognise notes and chords",
    bullets: [
        'Choose between notes and chords or have a mix of both',
        'Varying difficulty levels presenting more obscure chords'        
    ]
  } ,
  {
    date: 'March 11, 2026',
    title: "Would You Rather added", 
    gameClass: 'WouldYouRather',
    gameLabel: 'Would You Rather',
    summary: "A fun and engaging game where players choose between two challenging scenarios.",
    bullets: [
        'Players must choose between two difficult or amusing scenarios',
        'Encourages discussion and debate among players',
        'A great way to learn more about your friends and have fun in a social setting',
        'Score points for guessing the most popular choice among players, adding a competitive element to the game'
    ]
  },
  {
    date: 'March 11, 2026',
    title: "Crossword added",
    gameClass: 'Crossword',
    gameLabel: 'Crossword',
    summary: "Word puzzle game where players fill in a grid based on clues provided.",
    bullets: [
        'Players compete against each other to fill in the crossword grid based on given clues',
        'First to fill in all the words wins"'
    ]
  },
  {
    date: 'March 14, 2026',
    title: "Canasta added",
    gameClass: 'Canasta',
    gameLabel: 'Canasta',
    summary: "Canasta is a traditional card game based on forming melds and canastas.",
    bullets: [
        'Players compete against each other to form melds and canastas',
        'Highest score wins'
    ]
  },
  {
    date: 'March 18, 2026',
    title: "Go added",
    gameClass: 'Go',
    gameLabel: 'Go',
    summary: "A classic board game where players aim to control territory and capture stones.",
    bullets: [
        'Players compete against each other to control the most territory on the board',
        'Strategic placement of stones is key to winning'
    ]
  },
  {
    date: 'March 20, 2026',
    title: "Snakes and Ladders added",
    gameClass: 'SnakesAndLadders',
    gameLabel: 'Snakes and Ladders',
    summary: "Players navigate a board filled with snakes and ladders.",
    bullets: [
        'Players compete against each other to reach the end of the board first',
        'Landing on a ladder allows players to advance, while landing on a snake sends them backward',
        'Finish with an exact roll to win, adding an extra layer of excitement to the game'
    ]
  },
    {
    date: 'March 28, 2026',
    title: "Sudoku added",
    gameClass: 'Sudoku',
    gameLabel: 'Sudoku',
    summary: "A classic puzzle game where players fill a 9x9 grid with numbers.",
    bullets: [
        'Players compete against each other to complete the Sudoku grid',
        'Use logic and deduction to fill in the numbers correctly',
        'Challenge yourself with varying difficulty levels',
        'Pencil in possible numbers and use the process of elimination to solve the puzzle faster than your opponents'
    ]
  },
    {
    date: 'March 29, 2026',
    title: "Canvas Craze Improvements",
    gameClass: 'CanvasCraze',
    gameLabel: 'Canvas Craze',
    summary: "Improvements and new features added to Canvas Craze.",
    bullets: [
        'Enhanced drawing tools and brush options',
        'Improved performance and responsiveness',
        'New shapes and effects for more creative gameplay',
        'Bug fixes and stability improvements'
    ]
  },
    {
    date: 'April 4, 2026',
    title: "Spectator Mode added to all games and bug fixes",
    summary: "Spectator mode allows players to watch ongoing games without participating.",
    bullets: [
        'Players can now spectate any game in progress',
        'Improved performance and responsiveness for spectators',
        'New features for a better viewing experience',
        'Bug fixes and stability improvements'
    ]
  },
    {
    date: 'April 4, 2026',
    title: "Single Player Mode added",
    summary: "Single Player mode allows individuals to play certain games without needing more players. ",
    bullets: [
      "This is great for practicing or enjoying a game solo.",
      "Single Player mode is available for games that can be adapted for solo play, such as Word Search, Sudoku, and Hangman.",
      "More games will be added to Single Player mode over time based on player feedback and game mechanics."
        ]
  },
    {
    date: 'April 11, 2026',
    title: "Wheel of Destiny added",
    gameClass: 'WheelOfDestiny',
    gameLabel: 'Wheel of Destiny',
    summary: "Make difficult choices and see how your fate unfolds in Wheel of Destiny, a game of chance and strategy.",
    bullets: [
      "Configure the wheel with different outcomes and spin to see what happens",
      "Use the wheel to add an element of surprise and excitement to your game nights",
      "Change the weighting of outcomes to give certain results a higher chance of occurring, or keep it completely random for maximum suspense"
        ]
  },
    {
    date: 'April 17, 2026',
    title: "Eye for Detail added",
    gameClass: 'EyeForDetail',
    gameLabel: 'Eye for Detail',
    summary: "Test your observation skills and attention to detail in Eye for Detail.",
    bullets: [
      "Those with photographic memories will excel, but everyone can have fun trying to remember what they saw!",
      "Players study a scene filled with various items, then answer questions about what they observed"
        ]
  },
    {
    date: 'April 17, 2026',
    title: "Launch Links added",
    summary: "Easily launch games with specific configurations",
    bullets: [
      "Quickly start games with predefined settings for a seamless experience.",
      "Share launch URLs with friends to join games instantly.",
      "Customize game parameters directly from the URL for advanced setups.",
      "Perfect for bookmarking certain configurations of games without manual setup."
        ]
  }
  ,
    {
    date: 'April 19, 2026',
    title: "Solitaire added",
    gameClass: 'Solitaire',
    gameLabel: 'Solitaire', 
    summary: "Solitaire is a classic card game that challenges your strategic thinking and patience.",
    bullets: [
      "Players can now play Solitaire, a simple but addictive card game that challenges your strategic thinking and patience.",
      "The game features a familiar layout and rules, allowing players to enjoy the classic gameplay they know and love.",
      "Solitaire is a great addition for players who enjoy card games and want a relaxing yet engaging experience."
        ]
  }
,
    {
    date: 'April 27, 2026',
    title: "Minesweeper added",
    gameClass: 'Minesweeper',
    gameLabel: 'Minesweeper', 
    summary: "Minesweeper is a classic puzzle game that challenges your strategic thinking and patience.",
    bullets: [
      "Players can now play Minesweeper, a timeless puzzle game that challenges your strategic thinking and patience.",
      "Carefully uncover cells on the grid while avoiding hidden mines, using clues to deduce their locations.",
      "Take your time to analyze the board and make calculated moves, as one wrong click could end the game. Minesweeper is a great addition for players who enjoy logic puzzles and want a relaxing yet engaging experience."
        ]
  },
    {
    date: 'April 28, 2026',
    title: "Triangles added",
    gameClass: 'Triangles',
    gameLabel: 'Triangles', 
    summary: "Triangles is a strategic game where players take turns claiming edges on a grid to form triangles. The player with the most triangles at the end wins.",
    bullets: [
      "This is a strategic game where players take turns claiming edges on a grid to form triangles. The player with the most triangles at the end wins.",
      "Players must carefully choose which edges to claim, as claiming the wrong edge could give your opponent the opportunity to complete a triangle and score points."

        ]
  },
    {
    date: 'May 2, 2026',
    title: "Leaderboards introduced",
    summary: "Track your progress and compete with friends on the new leaderboards, available for certain games only",
    bullets: [
      "Players can now see how they rank against others in various games.",
      "Leaderboards provide a competitive edge and encourage players to improve their skills.",
      "Stay motivated by aiming for the top spots and earning recognition for your achievements."

        ]
  },
    {
    date: 'May 23, 2026',
    title: "Face Finder added",
    gameClass: 'FaceFinder',
    gameLabel: 'Face Finder',
    summary: "Test your observation skills and attention to detail in Face Finder.",
    bullets: [
      "Players can now challenge themselves in Face Finder, a game that tests your ability to spot differences and identify faces.",
      "Improve your memory and attention to detail while having fun.",
      "Compete with friends and see who has the sharpest eyes and most logical mind."

        ]
  },
  //   {
  //   date: 'May 30, 2026',
  //   title: "Slot Cars added",
  //   gameClass: 'SlotCars',
  //   gameLabel: 'Slot Cars', 
  //   summary: "Slot Cars is a thrilling racing game that tests your reflexes and strategy.",
  //   bullets: [
  //     "Players can now race against each other in Slot Cars, a fast-paced and exciting game.",
  //     "Customize your cars and tracks for a unique racing experience.",
  //     "Compete with friends and aim for the top positions on the leaderboards."

  //       ]
  // },
    {
    date: 'May 31, 2026',
    title: "Curling added",
    gameClass: 'Curling',
    gameLabel: 'Curling', 
    summary: "Curling is a strategic and exciting game that requires precision and skill.",
    bullets: [
      "Slide stones across the ice and aim for the target area, known as the house.",
      "Apply curve, spin and speed to your shots to outscore your opponents and win the game."

        ]
  }
  ,
    {
    date: 'May 31, 2026',
    title: "Ultimate Tic-Tac-Toe added",
    gameClass: 'UltimateTicTacToe',
    gameLabel: 'Ultimate Tic-Tac-Toe', 
    summary: "Ultimate Tic-Tac-Toe adds a new layer of strategy and complexity to the classic game, challenging players to think several moves ahead and adapt their tactics on the fly.",
    bullets: [
      "Players can now challenge themselves in Ultimate Tic-Tac-Toe, a more complex version of the classic game.",
      "Play on a 3x3 grid of tic-tac-toe boards, where each move determines the next board your opponent must play on.",
      "Strategize your moves to win individual boards and ultimately claim victory in the overall game."

        ]
  },
    {
    date: 'May 31, 2026',
    title: "2048 added",
    gameClass: 'Game2048',
    gameLabel: '2048', 
    summary: "2048 is a strategic and exciting game that challenges players to combine tiles and reach the coveted 2048 tile.",
    bullets: [
      "Combine tiles to reach higher numbers and ultimately achieve the 2048 tile.",
      "Compete with friends and aim for the highest score to prove your mastery of the game."

        ]
  },
    {
    date: 'July 25, 2026',
    title: "Territory added",
    gameClass: 'Territory',
    gameLabel: 'Territory', 
    summary: "Territory is a strategic game that challenges players to place markers correctly within a grid so that the rules are followed.",
    bullets: [
      "Place one marker per row, column, and territory without touching other markers.",
      "Compete with friends and aim to complete the grid quickest."

        ]
  },
  //   {
  //   date: 'July 25, 2026',
  //   title: "Video Chat added",
  //   gameClass: 'VideoChat',
  //   gameLabel: 'Video Chat', 
  //   summary: "Video Chat allows you to have a video call with other players in the same room.",
  //   bullets: [
  //     "Players can now video chat with friends while playing games.",
  //     "Supports multiple participants and provides a seamless communication experience."

  //       ]
  // },
    {
    date: 'July 25, 2026',
    title: "Closest Guess added",
    gameClass: 'ClosestGuess',
    gameLabel: 'Closest Guess', 
    summary: "Closest Guess is a game where players try to guess numeric answers as accurately as possible.",
    bullets: [
      "Provide the most accurate numeric answers.",
      "Score points based on how close your guess is to the target."

        ]
  }
];

function WhatsNew() {
  const sortedItems = [...WHATS_NEW_ITEMS].sort(
    (left, right) => new Date(right.date) - new Date(left.date)
  );
  
  return (
    <div className="w-full p-6">
      <div className="mx-auto max-w-4xl">
        <nav aria-label="Breadcrumb" className="mb-4">
          <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
            <Link
              to="/"
              className="font-medium transition-colors hover:text-slate-900 dark:hover:text-slate-100"
            >
              Lobby
            </Link>
            <span aria-hidden="true">/</span>
            <span className="font-medium text-slate-700 dark:text-slate-200">What&apos;s New</span>
          </div>
        </nav>

        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-[linear-gradient(135deg,#fff7ed_0%,#ffffff_38%,#eff6ff_100%)] p-8 shadow-sm dark:border-slate-700 dark:bg-[linear-gradient(135deg,#1e293b_0%,#111827_45%,#172554_100%)]">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-amber-600 dark:text-amber-300">
            What&apos;s New?
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-6 text-slate-600 dark:text-slate-300 sm:text-base">
            Recent updates to the games and gameplay experience will be listed here so you can stay up to date on what&apos;s new and exciting with Game for a Laugh, or GFAL as we like to call it. Check back often for the latest news and improvements!
          </p>
        </div>

        <div className="mt-8 space-y-4">
          {sortedItems.map((item) => {
            // Compute thumbnail path if gameClass exists
            let thumbSrc = null;
            if (item.gameClass) {
              // Lowercase, but keep underscores and numbers, and use _thumb.png
              thumbSrc = `/thumbnails/${item.gameClass}_thumb.png`;
            }
            return (
              <section
                key={`${item.date}-${item.title}`}
                className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900"
              >
                <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                  <div className="flex items-center gap-3">
                    {thumbSrc && (
                      <img
                        src={thumbSrc}
                        alt={item.gameClass + ' thumbnail'}
                        className="w-20 h-20 rounded-lg border border-slate-200 dark:border-slate-700 bg-white object-contain"
                        loading="lazy"
                        onError={e => { e.target.style.display = 'none'; }}
                      />
                    )}
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
                        {item.date}
                      </p>
                      <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-slate-100">
                        {item.title}
                      </h2>
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
                  {item.summary}
                </p>
                <ul className="mt-4 space-y-2 text-sm text-slate-700 dark:text-slate-200">
                  {item.bullets.map((bullet) => (
                    <li key={bullet} className="flex items-start gap-3">
                      <span className="mt-1 h-2 w-2 flex-shrink-0 rounded-full bg-amber-400" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
                {item.gameClass ? (
                  <div className="mt-5">
                    <Link
                      to="/"
                      state={{ openCreateRoom: true, createGameType: item.gameClass }}
                      className="inline-flex items-center rounded-full bg-amber-500 px-4 py-2 text-sm font-semibold text-gray-900 transition-colors hover:bg-amber-600 hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 dark:ring-offset-slate-900 shadow-md hover:shadow-lg duration-150"
                      style={{ transition: 'transform 0.15s, box-shadow 0.15s' }}
                    >
                      Create {item.gameLabel} Room
                    </Link>
                  </div>
                ) : null}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default WhatsNew;
